/**
 * Converts ISO/PostgreSQL timestamp string to 'Month Day, Year' (e.g., 'Nov 05, 2025').
 * Removes time/timezone for clean UI display.
 */
export const formatSimpleDate = (isoString) => {
  if (!isoString) return 'N/A';

  try {
    let dateInput = isoString;
    if (typeof isoString === 'string') {
      // Ensure string is a valid UTC ISO format (e.g., 'YYYY-MM-DDT...Z')
      if (!isoString.includes('T')) {
        dateInput = isoString.replace(' ', 'T');
      }
      if (!isoString.endsWith('Z') && !isoString.endsWith('+00')) {
        dateInput += 'Z';
      }
    }

    const date = new Date(dateInput);
    if (isNaN(date.getTime())) return 'Invalid Date';

    return new Intl.DateTimeFormat('en-US', {
      year: 'numeric',
      month: 'short',
      day: '2-digit',
    }).format(date);
  } catch (error) {
    console.error('formatSimpleDate error:', error, 'Input:', isoString);
    return 'Date Error';
  }
};